import Vue from 'vue'

import './styles/quasar.styl'
import './styles/global.css'
import 'quasar/dist/quasar.ie.polyfills'
import iconSet from 'quasar/icon-set/fontawesome-v5.js'
import materialIcon from 'quasar/icon-set/material-icons.js'
import materialOutlinedIcon from 'quasar/icon-set/material-icons-outlined.js'
import materialRoundIcon from 'quasar/icon-set/material-icons-round'
import ionIcon from 'quasar/icon-set/ionicons-v4'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/material-icons-round/material-icons-round.css'
import '@quasar/extras/ionicons-v4/ionicons-v4.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QFooter,
  QPageContainer,
  QPage,
  QPageScroller,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QImg,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QAvatar,
  QCard,
  QCardActions,
  QCardSection,
  QCheckbox,
  QChip,
  QBadge,
  QBtnDropdown,
  QBtnGroup,
  QBtnToggle,
  QDialog,
  QExpansionItem,
  QInput,
  QPagination,
  QPopupProxy,
  QMenu,
  QRadio,
  QSelect,
  QSlideItem,
  QSpace,
  QScrollArea,
  QTab,
  QTabPanel,
  QTabPanels,
  QTable,
  QTd,
  QTh,
  QTr,
  QToggle,
  ClosePopup,
  Dialog,
  Loading,
  Notify
} from 'quasar'

Vue.use(Quasar, {
  config: {
    notify: {}
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QFooter,
    QPageContainer,
    QPage,
    QPageScroller,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QImg,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QAvatar,
    QCard,
    QCardActions,
    QCardSection,
    QCheckbox,
    QChip,
    QBadge,
    QBtnDropdown,
    QBtnGroup,
    QBtnToggle,
    QDialog,
    QExpansionItem,
    QInput,
    QPagination,
    QPopupProxy,
    QMenu,
    QRadio,
    QSelect,
    QSlideItem,
    QSpace,
    QScrollArea,
    QTab,
    QTabPanel,
    QTabPanels,
    QTable,
    QTd,
    QTh,
    QTr,
    QToggle
  },
  directives: {
    ClosePopup
  },
  plugins: {
    Dialog,
    Loading,
    Notify
  },
  // 設定Quasar component使用的icon
  iconSet: iconSet,
  // other icon sources
  extra: {
    materialIcon,
    materialOutlinedIcon,
    materialRoundIcon,
    ionIcon
  }
})
